
import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

export const TestDeviceFormSchema = z.object({
  deviceTestCompletionDate: z.string({
    message: "Test Completion Date is required",
  }),
  nextStep: z.enum(["available", "live"], {
    message: "Please select a next step",
  }),
})

export type TestDeviceFormData = z.infer<typeof TestDeviceFormSchema>
